<ng-container [ngSwitch]="buttonState">
    <!-- Booked with partner -->
    <ng-container *ngSwitchCase="'bookedMatched'">
        <div
            class="flex flex-row items-center justify-between w-full h-10 border-2 border-[#7b7fc0] bg-[#f2f3fe] rounded-fm-5 !py-1.5 !px-2.5 shadow-fm-availability-item overflow-hidden gap-2.5">
            <app-profile-image
                *ngIf="!useTimeLabel; else keepLabelCentered"
                class="w-7"
                [profileImage]="profilePhoto"
                [snoozed]="false"
                [saved]="saved"
                size="xxsmall" />
            <ng-template #keepLabelCentered>
                <div class="w-7"></div>
            </ng-template>
            <div
                class="font-avenir font-semibold text-blurple text-sm text-ellipsis overflow-hidden whitespace-nowrap">
                <fa-icon
                    matTooltip="{{
                        displayName
                    }} will be your partner for this session unless one of you cancels"
                    matTooltipPosition="above"
                    matTooltipShowDelay="200"
                    matTooltipClass="f-tooltip"
                    *ngIf="isLockedIn"
                    class="mr-1.5 fa-icon-size-12"
                    [icon]="faLock"></fa-icon>
                <span>
                    @if (partnerQuietMode) {
                        <fm-quiet-mode-icon
                            tooltip="{{ displayName }} is in Quiet Mode"
                            class="inline-flex mr-0.5 text-blurple text-[12px]" />
                    }
                    {{ useTimeLabel ? sessionTimeLabel : displayName }}
                </span>
            </div>

            <div class="flex items-center justify-center xw-6 h-6">
                <fm-activity-type-icon
                    class="mr-2 text-[11px]"
                    [activityType]="sessionActivityType"
                    showTooltip="true" />
                <fa-icon
                    matTooltip="Cancel this session"
                    matTooltipPosition="above"
                    matTooltipShowDelay="200"
                    matTooltipClass="f-tooltip"
                    (click)="cancelSession($event)"
                    class="text-blurple text-right cursor-pointer"
                    [icon]="faTimes"></fa-icon>
            </div>
        </div>
    </ng-container>

    <!-- Booked No Partner -->
    <ng-container *ngSwitchCase="'bookedNoPartner'">
        <div
            class="flex flex-row items-center justify-between w-full h-10 border-2 border-[#7b7fc0] bg-[#f2f3fe] rounded-fm-5 !py-1.5 !px-2.5 shadow-fm-availability-item">
            <div class="w-7 min-w-7"></div>
            <div class="font-avenir text-sm font-semibold text-blurple"
                ><span>{{ buttonText }}</span></div
            >

            <div class="flex items-center justify-center w-6 h-6">
                <fa-icon
                    matTooltip="Cancel this session"
                    matTooltipPosition="above"
                    matTooltipShowDelay="200"
                    matTooltipClass="f-tooltip"
                    (click)="cancelSession($event)"
                    class="text-blurple text-right cursor-pointer"
                    [icon]="faTimes"></fa-icon>
            </div>
        </div>
    </ng-container>
    <!-- Confirm Cancel -->
    <ng-container *ngSwitchCase="'confirmCancel'">
        <div
            class="flex flex-row items-center justify-between w-full h-10 rounded-fm-5 shadow-fm-availability-item border-2 border-[#7680bf] overflow-hidden">
            <fm-button
                class="w-1/2 h-full"
                buttonType="cancel-confirm"
                animationType="spinner"
                [disabled]="cancelInProgress"
                (clicked)="cancelConfirmed()"
                [loading]="cancelInProgress"
                >Cancel</fm-button
            >

            <fm-button
                class="w-1/2 h-full"
                buttonType="cancel-keep"
                [disabled]="cancelInProgress"
                (clicked)="keepSession($event)"
                >Keep</fm-button
            >
        </div>
    </ng-container>
    <!-- Available session -->
    <ng-container *ngSwitchCase="'available'">
        <button
            *ngIf="!selected"
            [disabled]="disable"
            class="flex flex-row items-center justify-start w-full h-10 border-2 border-[#DADAED] bg-white rounded-fm-5 shadow-fm-availability-item !py-1.5 !px-2.5 gap-2.5 overflow-hidden hover:!bg-[#f9fafe] hover:!text-[#3b3d8c]"
            (click)="selectSession($event)">
            <app-profile-image
                *ngIf="!useTimeLabel"
                class="w-7"
                [profileImage]="profilePhoto"
                [snoozed]="false"
                [saved]="saved"
                size="xxsmall" />

            <div
                class="flex-1 text-center text-ellipsis whitespace-nowrap font-avenir text-sm font-semibold text-blurple overflow-hidden">
                @if (partnerQuietMode) {
                    <fm-quiet-mode-icon
                        tooltip="{{ displayName }} is in Quiet Mode"
                        class="inline-flex mr-0.5 text-blurple text-[12px]" />
                }
                {{ useTimeLabel ? sessionTimeLabel : displayName }}
            </div>
            <fm-activity-type-icon
                class="mr-0.5 text-[11px]"
                [activityType]="sessionActivityType"
                showTooltip="true" />
        </button>
        <app-spinner-button
            class="w-full shadow-fm-availability-item"
            *ngIf="selected"
            [disable]="false"
            [label]="'Confirm for ' + sessionTimeLabel + '?'"
            [faIcon]="faLock"
            [actionComplete]="bookingComplete"
            classes="flex flex-row items-center justify-center w-full h-10 border-1.5 border-[#B1B5DF] bg-blurple text-white font-avenir text-sm font-semibold rounded-md !py-1.5 px-3"
            (clicked)="bookSession($event)"></app-spinner-button>
    </ng-container>

    <ng-container *ngSwitchCase="'viewingSelf'">
        <div
            class="w-full overflow-hidden"
            matTooltip="Umm… you cannot book a session with yourself!"
            matTooltipPosition="below"
            matTooltipClass="f-tooltip"
            matTooltipShowDelay="500">
            <button
                disabled="true"
                *ngIf="!selected"
                class="flex flex-row items-center justify-start w-full h-10 border-2 border-[#DADAED] bg-white rounded-fm-5 shadow-fm !py-1.5 !px-2.5 gap-2.5">
                <div
                    class="flex-1 text-center text-ellipsis overflow-hidden whitespace-nowrap font-avenir text-sm font-semibold text-blurple">
                    {{ sessionTimeLabel }}</div
                >
            </button>
        </div>
    </ng-container>
</ng-container>
